import { Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FormField } from "./FormField";
import { EntityTable } from "./EntityTable";
import { useEntityCrud } from "./useEntityCrud";

const EntityDialog = ({ crud, title, fields, testId, wide }) => (
  <Dialog open={crud.open} onOpenChange={crud.setOpen}>
    <DialogContent className={`rounded-none max-h-[90vh] overflow-y-auto ${wide ? "max-w-3xl" : "max-w-lg"}`} data-testid={`${testId}-dialog`}>
      <DialogHeader>
        <DialogTitle className="font-heading font-black text-xl">{crud.editing ? "Modifier" : "Ajouter"} — {title}</DialogTitle>
        <DialogDescription>Les champs marqués * sont obligatoires.</DialogDescription>
      </DialogHeader>
      <form onSubmit={crud.save} className="grid sm:grid-cols-2 gap-4">
        {fields.map((f) => <FormField key={f.name} f={f} value={crud.form[f.name]} onChange={(v) => crud.setField(f.name, v)} testId={testId} />)}
        <DialogFooter className="sm:col-span-2 pt-2">
          <Button type="button" variant="outline" onClick={() => crud.setOpen(false)} className="rounded-none">Annuler</Button>
          <Button data-testid={`${testId}-save-btn`} type="submit" disabled={crud.saving} className="bg-red-600 hover:bg-red-700 rounded-none font-bold uppercase text-xs tracking-wider">{crud.saving ? "Enregistrement…" : "Enregistrer"}</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);

export const EntityManager = ({ title, description, listUrl, baseUrl, fields, columns, defaults, testId, wide, autoOpen, renderExtra, onChange }) => {
  const crud = useEntityCrud({ listUrl, baseUrl, fields, defaults, autoOpen, onChange });
  return (
    <div data-testid={`${testId}-manager`}>
      <div className="flex items-start justify-between gap-4 mb-6">
        <div><h1 className="font-heading text-3xl font-black">{title}</h1>{description && <p className="text-zinc-500 text-sm mt-1">{description}</p>}</div>
        <Button data-testid={`${testId}-add-btn`} onClick={crud.openNew} className="bg-red-600 hover:bg-red-700 rounded-none font-bold uppercase text-xs tracking-wider shrink-0"><Plus size={16} className="mr-1" /> Ajouter</Button>
      </div>
      <EntityTable items={crud.items} columns={columns} testId={testId} confirmId={crud.confirmId} onEdit={crud.openEdit} onDelete={crud.remove} />
      {renderExtra && renderExtra(crud.load)}
      <EntityDialog crud={crud} title={title} fields={fields} testId={testId} wide={wide} />
    </div>
  );
};
